module.exports = __webpack_public_path__ + "img/shipsen-man.6f5ff0ac.jpg";